<div class="flex align-items-center font-normal" [class]="onExtendedMobile() ? 'flex-column' : 'flex-row' ">
	<div *ngIf="!isDraftMode" [class]="onExtendedMobile() ? 'pb-2' : 'pr-4'">{{ 'SELECT_SITE' | translate }}</div>
	<div *ngIf="isDraftMode" [class]="onExtendedMobile() ? 'pb-2' : 'pr-4'">{{ 'SITE_MANAGEMENT' | translate }}</div>
	<div class="card border-round-2xl flex align-items-center justify-content-center pb-2" [class]="onExtendedMobile() ? 'w-full px-0' : ''" [ngClass]="getSelectableLayoutCard()" (click)="changeSite()">
		<div class="grid pt-1 flex align-items-center" [class]="onExtendedMobile() ? 'w-full' : 'w-25rem'">
			<div class="col-4 px-0 flex justify-content-center">
				<img *ngIf="site!== undefined" id="siteCardMobileImage" class="border-round-lg" [src]="imageSource().src">
			</div>
			<!-- NO DRAFT MODE -->
			<div *ngIf="!isDraftMode" class="col-6 px-0 py-0 flex flex-column justify-content-start">
				<div class="font-semibold">{{ (site!== undefined) ? (site.Name | truncate:[20]) : ('BUTTON_NOT_SELECT' | translate) }}</div>
				<div class="">{{ (site!== undefined && site.Description.length > 0) ? (site.Description | truncate:[20]): ('NO_DESCRIPTION' | translate) }}</div>
				<!-- <p-tag *ngIf="!isImpersMode" [icon]="isCurrentlyOwned() ? 'pi cm-user' : 'pi cm-share'" [value]="site?.User.FirstName + site?.User.LastName | truncate:[20]" 
					[styleClass]="isCurrentlyOwned() ? 'p-tag-slim p-tag-lightBlue0220' : 'p-tag-slim p-tag-purple'"></p-tag> -->
			</div>
			<div *ngIf="!isDraftMode" class="col-2 flex justify-content-center">
				<i class="pi cm-switch text-xl"></i>
			</div>
			<!-- DRAFT MODE -->
			<div *ngIf="isDraftMode" class="col-8 px-0 flex flex-column justify-content-start">
				<div class="font-semibold">{{ site !== undefined ? getTruncate(site.Name, 'long') : ('BUTTON_NOT_SELECT' | translate) }}</div>
				<div class="">{{ site !== undefined && site.Description.length > 0 ? getTruncate(site.Description, 'long') : ('NO_DESCRIPTION' | translate) }}</div>
			</div>
		</div>
	</div>
</div>